import React from 'react';
import HostsManagement from '../../components/hosts/HostsManagement';

const HostsPage = () => {
  return <HostsManagement />;
};

export default HostsPage;
